// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RiOMd","placeholdersHeader":"styles_placeholdersHeader__1hqV7","editorStyle":"styles_editorStyle__2QmDG","placeholdersBox":"styles_placeholdersBox__3Oi-t"};